/**
 * Training Page.
 *
 * Create shareable interview links to train Hobbes on customer products.
 * Also hosts the Evaluator (Simulations tab).
 */

import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PageHeader } from '@/components/layout/PageHeader';
import { HelpTooltip } from '@/components/ui/HelpTooltip';
import { InterviewerLinksContent } from '@/pages/platform_views/InterviewerSetupPage';
import { EvaluatorContent } from '@/pages/platform_views/EvaluatorPage';

const TrainingPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') === 'simulations' ? 'simulations' : 'training';
  const [activeTab, setActiveTab] = useState(initialTab);

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    if (value === 'simulations') {
      setSearchParams({ tab: 'simulations' }, { replace: true });
    } else {
      setSearchParams({}, { replace: true });
    }
  };

  return (
    <>
      <Helmet>
        <title>{activeTab === 'simulations' ? 'Simulations' : 'Agent Training'} | Hobbes</title>
      </Helmet>

      <div className="flex min-h-0 flex-col">
        <PageHeader
          title={<>Agent Training <HelpTooltip text="Teach your agent about your product." /></>}
        />

        {/* Tabs + Content */}
        <div className="flex-1 px-4 sm:px-6 md:px-8 py-6">
          <Tabs value={activeTab} onValueChange={handleTabChange}>
            <TabsList className="mb-6">
              <TabsTrigger value="training">Training</TabsTrigger>
              <TabsTrigger value="simulations">Simulations</TabsTrigger>
            </TabsList>
            <TabsContent value="training">
              <InterviewerLinksContent />
            </TabsContent>
            <TabsContent value="simulations">
              <EvaluatorContent />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default TrainingPage;
